export default "__VITE_ASSET__Bb9KjARm__"